import * as Safe from "safe-portals";
import { PLUGIN_NAME } from "./constants";
import { makeActionTypeDefinition } from "@flow/common/action_type";

const ActionFrontendDataSerializer = Safe.obj({
  title: Safe.str,
  body: Safe.str,
  nextButtonText: Safe.str,
});

export type ActionCustomData = Safe.TypeIn<typeof ActionFrontendDataSerializer>;

export const html_action_type = makeActionTypeDefinition({
  plugin: PLUGIN_NAME,
  action_type: "html-action",
  supports_a_b_tests: true,
  custom_config_type: Safe.obj({
    title: Safe.str,
    body: Safe.str,
    nextButtonText: Safe.str,
  }),
  custom_config_defaults: {
    title: "",
    body: "",
    nextButtonText: "Next",
  },
  custom_data_type: ActionFrontendDataSerializer,
  check_valid: (config) => {
    const errors: Record<string, string> = {};

    if (config.title.length === 0) {
      errors.title = "Title is required";
    }

    return { valid: Object.keys(errors).length === 0, errors: errors };
  },
});

export const redirect_action_type = makeActionTypeDefinition({
  plugin: PLUGIN_NAME,
  action_type: "redirect-action",
  supports_a_b_tests: false,
  custom_config_type: Safe.obj({
    redirectUrl: Safe.str,
  }),
  custom_config_defaults: { redirectUrl: "/redirect-not-set" },
  custom_data_type: Safe.obj({
    permitted_insecure_redirect_url_prefixes: Safe.array(Safe.str),
    redirectUrl: Safe.str,
  }),
  check_valid: (config) => {
    const errors: Record<string, string> = {};

    if (config.redirectUrl.length === 0) {
      errors.redirectUrl = "Redirect URL is required";
    }

    return { valid: Object.keys(errors).length === 0, errors: errors };
  },
});
